export default "__VITE_ASSET__Bht0IHCV__"